import React, { useState, useEffect } from "react";
import { getInvoiceBundleFiles } from "API/swesum";

import usePost from "Hooks/usePost";
import Textfield from "Components/UI/Form/Textfield";

//MUI
import Grid from "@mui/material/Grid";
import { Button, Typography } from "@mui/material";

export default function GetInvoiceBundles() {
  const [message, setMessage] = useState("");

  const getInvoiceBundlesReq = usePost({
    mtnFunc: (body) => getInvoiceBundleFiles(),
    onError: (data) => {
      setMessage(`${data.response.statusText} (${data.response.status})`);
    },
    onSuccess: (data) => {
      setMessage(data.Message);
    },
  });

  return (
    <>
      <Typography variant="h6" sx={{ pt: 4, pb: 6 }}>
        Hämta fakturabuntar från FTP-area.
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield disabled label="Meddelande" value={message} />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button onClick={() => getInvoiceBundlesReq.post()} variant="contained">
          Starta
        </Button>
      </Grid>
    </>
  );
}
